import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mb-20px"
};
const _hoisted_2 = {
  class: "mb-20px flex justify-between items-center"
};
const _hoisted_3 = {
  class: "text-16px font-bold flex items-center"
};
const _hoisted_4 = {
  class: "segment-settings mb-20px"
};
const _hoisted_5 = {
  class: "mb-10px max-h-[500px] overflow-auto"
};
const _hoisted_6 = {
  class: "file-selector mb-10px"
};
const _hoisted_7 = {
  class: "flex items-center cursor-pointer"
};
const _hoisted_8 = {
  key: 0,
  class: "ml-5px text-gray-500 text-12px"
};
const _hoisted_9 = {
  key: 0,
  class: "ml-5px text-gray-500 text-12px"
};
const _hoisted_10 = {
  key: 1,
  class: "text-gray-400"
};
const _hoisted_11 = {
  class: "file-preview bg-gray-50 p-15px rounded-md max-h-600px overflow-y-auto"
};
const _hoisted_12 = {
  key: 0,
  class: "flex justify-center items-center py-20px"
};
const _hoisted_13 = {
  class: "text-gray-500 text-12px mb-5px"
};
const _hoisted_14 = {
  class: "bg-white p-10px rounded-md"
};
const _hoisted_15 = {
  class: "mt-20px flex justify-between"
};
import { computed, getCurrentInstance, inject, onMounted, ref } from 'vue';
import { Icon } from '@/components/Icon';
import { KnowledgeSegmentApi } from '@/api/ai/knowledge/segment';
import { useMessage } from '@/hooks/web/useMessage';
import { KnowledgeDocumentApi } from '@/api/ai/knowledge/document';
export default /*@__PURE__*/_defineComponent({
  __name: 'SplitStep',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const message = useMessage(); // 消息提示
    const parent = inject('parent', null); // 获取父组件实例
    const modelData = computed({
      get: () => props.modelValue,
      set: val => emit('update:modelValue', val)
    }); // 表单数据
    const splitLoading = ref(false); // 分段加载状态
    const currentFile = ref(null); // 当前选中的文件
    const submitLoading = ref(false); // 提交按钮加载状态
    /** 选择文件 */
    const selectFile = async index => {
      currentFile.value = modelData.value.list[index];
      await splitContent(currentFile.value);
    };
    /** 获取文件分段内容 */
    const splitContent = async file => {
      if (!file || !file.url) {
        message.warning('文件 URL 不存在');
        return;
      }
      splitLoading.value = true;
      try {
        // 调用后端分段接口，获取文档的分段内容、字符数和 Token 数
        file.segments = await KnowledgeSegmentApi.splitContent(file.url, modelData.value.segmentMaxTokens);
      } catch (error) {
        console.error('获取分段内容失败:', file, error);
      } finally {
        splitLoading.value = false;
      }
    };
    /** 处理预览分段 */
    const handleAutoSegment = async () => {
      // 如果没有选中文件，默认选中第一个
      if (!currentFile.value && modelData.value.list && modelData.value.list.length > 0) {
        currentFile.value = modelData.value.list[0];
      }
      // 如果没有选中文件，提示请先选择文件
      if (!currentFile.value) {
        message.warning('请先选择文件');
        return;
      }
      // 获取分段内容
      await splitContent(currentFile.value);
    };
    /** 上一步按钮处理 */
    const handlePrevStep = () => {
      const parentEl = parent || getCurrentInstance()?.parent;
      if (parentEl && typeof parentEl.exposed?.goToPrevStep === 'function') {
        parentEl.exposed.goToPrevStep();
      }
    };
    /** 保存操作 */
    const handleSave = async () => {
      // 保存前验证
      if (!currentFile?.value?.segments || currentFile.value.segments.length === 0) {
        message.warning('请先预览分段内容');
        return;
      }
      // 设置按钮加载状态
      submitLoading.value = true;
      try {
        if (modelData.value.id) {
          // 修改场景
          await KnowledgeDocumentApi.updateKnowledgeDocument({
            id: modelData.value.id,
            segmentMaxTokens: modelData.value.segmentMaxTokens
          });
        } else {
          // 新增场景
          const data = await KnowledgeDocumentApi.createKnowledgeDocumentList({
            knowledgeId: modelData.value.knowledgeId,
            segmentMaxTokens: modelData.value.segmentMaxTokens,
            list: modelData.value.list.map(item => ({
              name: item.name,
              url: item.url
            }))
          });
          modelData.value.list.forEach((document, index) => {
            document.id = data[index];
          });
        }
        // 进入下一步
        const parentEl = parent || getCurrentInstance()?.parent;
        if (parentEl && typeof parentEl.exposed?.goToNextStep === 'function') {
          parentEl.exposed.goToNextStep();
        }
      } catch (error) {
        console.error('保存失败:', modelData.value, error);
      } finally {
        // 关闭按钮加载状态
        submitLoading.value = false;
      }
    };
    /** 初始化 */
    onMounted(async () => {
      // 确保 segmentMaxTokens 存在
      if (!modelData.value.segmentMaxTokens) {
        modelData.value.segmentMaxTokens = 500;
      }
      // 如果没有选中文件，默认选中第一个
      if (!currentFile.value && modelData.value.list && modelData.value.list.length > 0) {
        currentFile.value = modelData.value.list[0];
      }
      // 如果有选中的文件，获取分段内容
      if (currentFile.value) {
        await splitContent(currentFile.value);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_empty = _resolveComponent("el-empty");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createTextVNode(" 分段设置 ")), _createVNode(_component_el_tooltip, {
        content: "系统会自动将文档内容分割成多个段落，您可以根据需要调整分段方式和内容。",
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Icon), {
          icon: "ep:warning",
          class: "ml-5px text-gray-400"
        })]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small",
        onClick: handleAutoSegment
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" 预览分段 ")])),
        _: 1
      })])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        "label-width": "120px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "最大 Token 数"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: modelData.value.segmentMaxTokens,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => modelData.value.segmentMaxTokens = $event),
            min: 1,
            max: 2048
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_5, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "text-16px font-bold mb-10px"
      }, "分段预览", -1)), _createElementVNode("div", _hoisted_6, [modelData.value.list && modelData.value.list.length > 0 ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelData.value.list, (file, index) => {
            return _openBlock(), _createBlock(_component_el_dropdown_item, {
              key: index,
              onClick: $event => selectFile(index)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(file.name) + " ", 1), file.segments ? (_openBlock(), _createElementBlock("span", _hoisted_9, " (" + _toDisplayString(file.segments.length) + "个分片) ", 1)) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["onClick"]);
          }), 128))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_unref(Icon), {
          icon: "ep:document",
          class: "text-danger mr-5px"
        }), _createElementVNode("span", null, _toDisplayString(currentFile.value?.name || '请选择文件'), 1), currentFile.value?.segments ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(currentFile.value.segments.length) + "个分片) ", 1)) : _createCommentVNode("", true), _createVNode(_unref(Icon), {
          icon: "ep:arrow-down",
          class: "ml-5px"
        })])]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_10, "暂无上传文件"))]), _createElementVNode("div", _hoisted_11, [splitLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_unref(Icon), {
        icon: "ep:loading",
        class: "is-loading"
      }), _cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "ml-10px"
      }, "正在加载分段内容...", -1))])) : currentFile.value && currentFile.value.segments && currentFile.value.segments.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(currentFile.value.segments, (segment, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "mb-10px"
        }, [_createElementVNode("div", _hoisted_13, " 分片-" + _toDisplayString(index + 1) + " · " + _toDisplayString(segment.contentLength || 0) + " 字符数 · " + _toDisplayString(segment.tokens || 0) + " Token ", 1), _createElementVNode("div", _hoisted_14, _toDisplayString(segment.content), 1)]);
      }), 128)) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 2,
        description: "暂无预览内容"
      }))])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, [!modelData.value.id ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: handlePrevStep
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("上一步")])),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        loading: submitLoading.value,
        onClick: handleSave
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode(" 保存并处理 ")])),
        _: 1
      }, 8, ["loading"])])])]);
    };
  }
});